"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _StyledLayout = require("../../../../../StyledLayout");

var _StyledTypography = require("../../../../../StyledTypography");

var _Elements = require("../../../../Elements");

var _SocialGroup = _interopRequireDefault(require("../../../../common/components/SocialGroup"));

var _Elements2 = require("./Elements");

var _helpers = require("../../../../common/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var About = function About(_ref) {
  var description = _ref.description,
      cover = _ref.cover,
      visibilityOptions = _ref.visibilityOptions,
      socialMedia = _ref.socialMedia,
      username = _ref.username,
      colour = _ref.colour,
      location = _ref.location;
  var aboutBoxRef = (0, _react.useRef)(null);
  var isDesktopLarge = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1900px)'
  });
  var isDesktopMedium = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1440px)'
  });
  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1024px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var descriptionElements = (0, _helpers.generateParagraphs)({
    description: description,
    isDesktopSmall: isDesktopSmall
  });
  var contentWidth = (0, _react.useMemo)(function () {
    if (isDesktopLarge) {
      return 656;
    }

    if (isDesktopMedium) {
      return 536;
    }

    if (isDesktopSmall) {
      return 392;
    }

    if (isTabletLandScape) {
      return 656;
    }

    if (isTabletPortrait) {
      return 504;
    }

    return window.innerWidth - 32;
  }, [isDesktopLarge, isDesktopMedium, isDesktopSmall, isTabletPortrait, window.innerWidth]);
  var hasSocialMedia = !!socialMedia.twitter || !!socialMedia.facebook || !!socialMedia.instagram || visibilityOptions.pxProfile === 'VISIBLE';
  (0, _react.useEffect)(function () {
    var _aboutBoxRef$current, _aboutBoxRef$current$, _aboutBoxRef$current2, _aboutBoxRef$current3;

    // eslint-disable-next-line no-unused-expressions
    aboutBoxRef === null || aboutBoxRef === void 0 ? void 0 : (_aboutBoxRef$current = aboutBoxRef.current) === null || _aboutBoxRef$current === void 0 ? void 0 : (_aboutBoxRef$current$ = _aboutBoxRef$current.focus) === null || _aboutBoxRef$current$ === void 0 ? void 0 : _aboutBoxRef$current$.call(_aboutBoxRef$current); // eslint-disable-next-line no-unused-expressions

    aboutBoxRef === null || aboutBoxRef === void 0 ? void 0 : (_aboutBoxRef$current2 = aboutBoxRef.current) === null || _aboutBoxRef$current2 === void 0 ? void 0 : (_aboutBoxRef$current3 = _aboutBoxRef$current2.scrollTo) === null || _aboutBoxRef$current3 === void 0 ? void 0 : _aboutBoxRef$current3.call(_aboutBoxRef$current2, 0, 0);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledAboutBox, {
    tabIndex: "0",
    ref: aboutBoxRef,
    p: "sm",
    isTabletPortrait: isTabletPortrait
  }, isDesktopSmall ? /*#__PURE__*/_react["default"].createElement(_StyledTypography.Headline, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    normal: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.about"
  })) : /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingLarge, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    normal: true,
    mb: "md"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.caption.about"
  })), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    column: !isDesktopSmall,
    style: {
      flexDirection: isDesktopSmall ? 'unset' : 'column-reverse'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.StyledIntroBox, {
    mr: "md",
    width: contentWidth,
    isTabletPortrait: isTabletPortrait
  }, descriptionElements, location && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    small: !isTabletLandScape,
    bold: true,
    portfolioForeground2: true,
    mb: "xs",
    mt: "sm",
    center: !isTabletPortrait
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.caption.location"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    center: !isTabletPortrait,
    mb: "md"
  }, location)), hasSocialMedia && /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    portfolioFontFamily: true,
    portfolioForeground2: true,
    bold: true,
    center: !isTabletPortrait,
    small: !isTabletLandScape
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.about.follow_me"
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.StyledShareIconBox, {
    flex: true,
    justify: !isTabletPortrait ? 'center' : 'left'
  }, /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions,
    username: username,
    fontColor: colour
  }))), /*#__PURE__*/_react["default"].createElement(_Elements2.StyledCoverBox, {
    width: contentWidth,
    isTabletPortrait: isTabletPortrait
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.Image, {
    src: cover
  }))));
};

About.defaultProps = {
  cover: '',
  socialMedia: {
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    pxProfile: 'VISIBLE'
  },
  username: '',
  colour: '',
  location: ''
};
About.propTypes = {
  cover: _propTypes["default"].string,
  description: _propTypes["default"].string.isRequired,
  socialMedia: _propTypes["default"].shape({
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  }),
  username: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  location: _propTypes["default"].string
};
var _default = About;
exports["default"] = _default;